import React from "react";
import { useState } from "react";
import SellerForm1 from "../components/Forms/SellerForm1";
import Seller from "./Seller";
import TaxDetails from "../components/Forms/TaxDetails";
import SellerInformation from "../components/Forms/SellerInformation";
import { MdCheckCircle } from "react-icons/md";
import SellerInterview from "../components/Forms/SellerInterview";
import DashboarForSeller from "./DashboarForSeller";
const stepsForSellerRegistration = {
  1: Seller,
  2: SellerForm1,
  3: TaxDetails,
  4: SellerInformation,
  5: SellerInterview,
  6: DashboarForSeller,
};

const SellerRegistration = () => {
  const [step, setstep] = useState(1);
  const Step = stepsForSellerRegistration[step];

  const onNext = () => {
    setstep(step + 1);
  };

  return (
    <>
      <div
        className={`${
          step === 1 ? "hidden" : "flex"
        } w-full border px-1  md:justify-center justify-between flex-wrap `}
      >
        <div className="flex md:justify-center items-center md:w-48 w-32 py-2">
          <MdCheckCircle className="text-lg text-green-700" />
          <h1 className="text-xs font-semibold text-green-600 ml-2">
            Phone verification
          </h1>
        </div>
        <div className="flex md:justify-center items-center md:w-48 w-32 py-2 ">
          <MdCheckCircle className="text-lg text-green-700" />
          <h1 className="text-xs font-semibold text-green-600 ml-2">
            Seller Information
          </h1>
        </div>
        <div className="flex md:justify-center items-center md:w-48 w-32 py-2 ">
          <MdCheckCircle className="text-lg text-green-700" />
          <h1 className="text-xs font-semibold text-green-600 ml-2">
            Tax Details
          </h1>
        </div>
        <div className="flex md:justify-center items-center md:w-48 w-32 py-2 ">
          <MdCheckCircle className="text-lg text-green-700" />
          <h1 className="text-xs font-semibold text-green-600 ml-2">
            Seller Interview
          </h1>
        </div>
        <div className="flex md:justify-center items-center md:w-48 w-32 py-2 ">
          <MdCheckCircle className="text-lg text-green-700" />
          <h1 className="text-xs font-semibold text-green-600 ml-2">
            Dashboard
          </h1>
        </div>
      </div>

      <Step onNext={onNext} />
    </>
  );
};

export default SellerRegistration;
